export default "images/back.png";